module.exports = __webpack_public_path__ + "img/spider_crab.91895a9f.png";